import React, { Component } from "react";

import "./style.css";

export default class CustomList extends Component {
  render() {
    const { data } = this.props;
    return (
      <ul className="custom-list-container my-2">
        {Object.keys(data).map((key, i) => {
          return (
            <li key={i}>
              <span>{key}</span>
              <span>{data[key]}</span>
            </li>
          );
        })}
      </ul>
    );
  }
}
